import { getMetric } from "@/lib/metrics";
import type { OverviewKpis } from "@/lib/types";

/** Single KPI tile rendered inside the 2×2 predictions grid. Mirrors
 *  the structural layout of `ConfigurableKpi` (label → value → foot)
 *  but without the pencil picker, sparkline, or period comparison —
 *  these metrics don't have a daily series or a stable prior-period
 *  baseline (D30 predictions only make sense at the current window
 *  horizon). */
export function PredictionKpiTile({
  metricId,
  kpis,
}: {
  metricId: string;
  kpis: OverviewKpis;
}) {
  const m = getMetric(metricId);
  const v = m.fromKpis(kpis);

  return (
    <div className="kpi">
      <div className="kpi-label">{m.label}</div>
      <div className="kpi-value">
        {m.unit === "$" && <small>$</small>}
        <span>{m.fmt(v)}</span>
        {m.unit && m.unit !== "$" && <small>{m.unit}</small>}
      </div>
      <div className="kpi-foot">
        <span className="muted">
          {v == null ? "No prediction rule for this org" : "Based on trial-started × rule"}
        </span>
      </div>
    </div>
  );
}
